import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'

import { useOnboardingContext } from '../../providers/OnboardingProvider'

export function OnboardingRoot() {
    const { pathname } = useLocation()
    const { advanceOnboardingState } = useOnboardingContext()

    useEffect(() => {
        if (
            pathname === '/onboarding' ||
            pathname === '/onboarding/' ||
            pathname === '/golive' ||
            pathname === '/golive/'
        ) {
            advanceOnboardingState()
        }
    }, [pathname])

    return <Outlet />
}
